export function VolumeOnIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.3"
        d="M16.3154 16.1482C15.9539 16.3504 15.4969 16.2212 15.2948 15.8597C15.0926 15.4982 15.2218 15.0412 15.5833 14.839C16.6044 14.268 17.2499 13.191 17.2499 12C17.2499 10.8179 16.614 9.74761 15.6047 9.17314C15.2448 8.96823 15.1191 8.5103 15.324 8.15032C15.5289 7.79034 15.9868 7.66463 16.3468 7.86954C17.82 8.7081 18.7499 10.2732 18.7499 12C18.7499 13.7397 17.806 15.3147 16.3154 16.1482ZM16.7886 19.8893C16.4154 20.0688 15.9672 19.9118 15.7877 19.5385C15.6081 19.1653 15.7651 18.7171 16.1384 18.5375C18.6311 17.3384 20.2499 14.8153 20.2499 12C20.2499 9.21176 18.6621 6.70866 16.206 5.49549C15.8346 5.31205 15.6822 4.86228 15.8657 4.4909C16.0491 4.11952 16.4989 3.96716 16.8703 4.1506C19.8334 5.61421 21.7499 8.6355 21.7499 12C21.7499 15.3972 19.796 18.4426 16.7886 19.8893Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 16L3.60777 15.3215C2.67292 15.1346 2 14.3137 2 13.3604V10.6396C2 9.68622 2.67292 8.86539 3.60777 8.67842L7 7.99997L10.2929 4.70708C10.6834 4.31655 11.3166 4.31655 11.7071 4.70708C11.8946 4.89461 12 5.14897 12 5.41418V18.5858C12 19.138 11.5523 19.5858 11 19.5858C10.7348 19.5858 10.4804 19.4804 10.2929 19.2929L7 16Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default VolumeOnIcon;
